import Attributes from './attributes/PluginSetup'
import DataViewers from './dataViewers/PluginSetup'
import Renderers from './renderers/PluginSetup'
import ScreenSetup from './screens/PluginSetup'
import DataSourceSetup from './dataSources/PluginSetup'

export default {
  install( molten ) {
    DataViewers.install( molten )
    ScreenSetup.install( molten )
    Attributes.install( molten )
    Renderers.install( molten )
    DataSourceSetup.install( molten )
  }
}
